import http from '@/http';

export default {
    get(demandId, userId) {
        return http.get(`/evaluations?demandId=${demandId}&userId=${userId}`);
    },
    save(form) {
        return http.post('/evaluations', form);
    },
    update(id, form) {
        return http.put(`/evaluations/${id}`, form);
    },
    remove(id) {
        return http.delete(`/evaluations/${id}`);
    },
};



// WEBPACK FOOTER //
// ./src/api/evaluations.js